// Quick-reply chip titles are looked up via i18n keys (see SystemPrompt) rather than hardcoded
// here, so the label id (used for click prefill + selected-state comparisons) stays stable while
// copy is translatable.
const systemPrompts = [
  {
    id: "book_a_trip",
    titleKey: "ai_assistant.chips.book_a_trip"
  },
  {
    id: "show_todays_bookings",
    titleKey: "ai_assistant.chips.show_todays_bookings"
  },
  {
    id: "process_a_refund",
    titleKey: "ai_assistant.chips.process_a_refund"
  },
  {
    id: "manage_bookings",
    titleKey: "ai_assistant.chips.manage_bookings"
  }
]
export { systemPrompts }
